module.exports = __webpack_public_path__ + "static/img/2.f7137b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/line/2.jpg
// module id = +1EJ
// module chunks = 1